<template>
  <main class="implants-page">
    <section class="silimed">
      <h2 class="section-title">{{ $t('underwear.start')}}</h2>

    <div class="silimed-buttons animate-element" ref="silimedButtons">
      <a href="#" @click="goToHowToSuit">{{ $t('underwear.suit') }}</a>
      <a href="#" @click="goToHowToWash">{{ $t('underwear.wash')}}</a>
    </div>

      <div class="silimed-banner">
        <img src="/img/Invo.jpg" alt="Silimed">
      </div>
    
      <div class="silimed-text">
        <h2>{{ $t('underwear.compress')}}</h2>
        <p>{{  $t('underwear.p1') }}</p>
        <P>{{ $t('underwear.p2')}}</P>
        <P>{{ $t('underwear.p3')}}</P>
        <P>{{ $t('underwear.p4')}}</P>
      </div>
    </section>
  </main>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'MainImplants',
  data() {
    return {
      showCurve: true
    }
  },

  setup() {
    const router = useRouter()

    function goToHowToSuit() {
      router.push("/howtosuit")
    }
    function goToHowToWash() {
      router.push("/howtowash")
    }

    return { goToHowToSuit, goToHowToWash }
  },

  methods: {
    switchLang(lang) {
      this.$i18n.locale = lang
    }
  }
}
</script>


<style scoped>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* ===== БАЗА (Desktop 2K / Full HD) ===== */
.silimed {
  text-align: center;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.section-title {
  color: #505050;
  font-size: 36px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 100px;
}

.silimed-banner img {
  height: 200px;
  margin: auto;
  display: block;
}

.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap; /* чтобы не ломались на малых экранах */
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 50px;
  min-width: 220px;
  padding: 10px 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
  border-radius: 6px;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}

.silimed-text {
  max-width: 1160px;
  margin: 0 auto;
  text-align: left;
}

.silimed-text h2 {
  color: #0d1016;
  font-size: 30px;
  font-weight: 100;
  margin-bottom: 25px;
}

.silimed-text p {
  font-weight: 300;
  line-height: 30px;
  margin-bottom: 25px;
  color: #555;
  font-size: 18px;
}


/* ===== 1440px (ноутбуки) ===== */
@media (max-width: 1440px) {
  .section-title {
    font-size: 32px;
    margin-bottom: 80px;
  }

  .silimed-text h2 {
    font-size: 26px;
  }

  .silimed-text p {
    font-size: 16px;
    line-height: 28px;
  }
}

/* ===== 1024px (планшеты) ===== */
@media (max-width: 1024px) {
  .section-title {
    font-size: 28px;
    margin-bottom: 60px;
  }

  .silimed-banner img {
    height: 150px;
  }

  .silimed-buttons {
    gap: 20px;
  }

  .silimed-buttons a {
    min-width: 180px;
    font-size: 14px;
    line-height: 40px;
  }

  .silimed-text h2 {
    font-size: 24px;
  }

  .silimed-text p {
    font-size: 15px;
    line-height: 26px;
  }
}

/* ===== 768px (малые планшеты / большие телефоны) ===== */
@media (max-width: 768px) {
  .section-title {
    font-size: 24px;
    margin-bottom: 40px;
  }

  .silimed-banner img {
    width: 100%;
    height: auto;
  }

  .silimed-buttons {
    flex-direction: column;
    gap: 15px;
  }

  .silimed-buttons a {
    width: 100%;
    min-width: unset;
    font-size: 14px;
    line-height: 40px;
  }

  .silimed-text h2 {
    font-size: 20px;
  }

  .silimed-text p {
    font-size: 14px;
    line-height: 24px;
  }
}

/* ===== 480px (мобильные) ===== */
@media (max-width: 480px) {
  .section-title {
    font-size: 20px;
    line-height: 28px;
  }

  .silimed-banner img {
    width: 100%;
    height: auto;
  }

  .silimed-buttons {
    gap: 10px;
  }

  .silimed-buttons a {
    font-size: 13px;
    padding: 8px 12px;
    line-height: 36px;
  }

  .silimed-text h2 {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .silimed-text p {
    font-size: 13px;
    line-height: 22px;
  }
}

</style>